// Libs
import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';
// Components, Layouts, Pages
// Others
// Styles, images, icons
import { images } from '~/assets';

const Logo = () => {
  //#region Destructuring Props
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <View style={styles.container}>
      <View>
        <Image style={styles.logo} src={images.imgLogo} />
      </View>

      <View style={styles.viewText}>
        <Text style={styles.textLogo}>NOBLE PLUMBING, Inc</Text>
        <Text style={styles.text}>1219 Kanasas Ave, 1</Text>
        <Text style={styles.text}>Modesto, CA 95351</Text>
      </View>
    </View>
  );
};

export default Logo;

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: 2,
  },

  logo: {
    width: 175,
    height: 40,
  },

  viewText: {
    gap: 5,
  },

  textLogo: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#2A3962',
  },

  text: {
    fontSize: 12,
    color: '#2A3962',
  },
});
